import {Injectable, Inject} from 'ng-metadata/core';
import {getVid} from '../../../appConfig/appConfigForward';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';

@Injectable()
export class AuthoritySearchBarService {

    private _searchBarInput: string;
    private _selectedScope;
    public SEARCH_FIELD_SCOPES :string[];


    constructor(private mappingTablesCache : MappingTablesCache){
        this.SEARCH_FIELD_SCOPES = this.authoritySearchScopesList;
    }

    public get searchBarInput(): string{
        return this._searchBarInput;
    }

    public set searchBarInput(newSearchInput: string){
        this._searchBarInput= newSearchInput;
    }

    public get selectedScope(){
        return this._selectedScope;
    }

    public set selectedScope(newScope){
        this._selectedScope= newScope;
    }

    private get authoritySearchScopesList() {
        return this.authoritySearchScopesObjFromConf.map(mt => mt.target);
    }

    private get authoritySearchScopesObjFromConf() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.AUTHORITY_SEARCH_SCOPES,
            {source1: getVid()});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/authority/authoritySearchBar/authoritySearchBar.service.ts